<template>
    <div>
        <el-card>
            <div class="boxClass">
                <span>服务台</span>
                <div>
                    <router-link :to="{ path: '/personnelEventStatis'}">
                        <span>人员事件统计</span>
                    </router-link>
                    <router-link :to="{ path: '/greatEventStatis'}">
                        <span>重大事件统计</span>
                    </router-link>
                    <router-link :to="{ path: '/eventCloseStatis'}">
                        <span>事件关闭统计</span>
                    </router-link>
                    <router-link :to="{ path: '/eventFinishedStatis'}">
                        <span>事件完成统计</span>
                    </router-link>
                    <router-link :to="{ path: '/eventOriginStatais'}">
                        <span>事件来源统计</span>
                    </router-link>
                    <router-link :to="{ path: '/efficientAndRespond'}">
                        <span>工作效率以及响应</span>
                    </router-link>
                </div>
                
            </div>
        </el-card>
    </div>
</template>

<script>
    
    export default {
        
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .boxClass{
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        &>span{
            font-size: 16px;
            font-weight: 700;
            margin-bottom: 10px;
        }
        &>div{
            display: flex;
            flex-wrap:wrap;
            span{
                color:#303133!important;
                margin-right: 30px;
            }
        }
    }
</style>